import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { MortgageAnnotations } from '@cian/adfox-templates';
import { Button, UIHeading1, UIHeading2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { Marquee } from 'shared/components/Marquee';

import { TSpecialProjectBannerContext } from '../../types';

import styles from './SpecialProjectBanner.css';

type TSpecialProjectBannerProps = {
  sizes: TAdFoxBannerCompleteSizes;
  context: TSpecialProjectBannerContext;
};

export const SpecialProjectBanner: FC<TSpecialProjectBannerProps> = ({ context, sizes }) => {
  const {
    bgImage,
    title,
    text,
    url,
    buttonText,
    substrateNotNeeded,
    substrateLogoNotNeeded,
    logo,
    label,
    disclaimer,
    mortgageTermsWarning,
    mortgageWarning,
  } = context;

  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <div className={styles['block-wrapper']} data-testid="SpecialProjectBanner">
      <a
        className={clsx(
          styles['container'],
          !Number(substrateNotNeeded) && styles['container--without-substrate'],
          !Number(substrateLogoNotNeeded) && styles['container--without-substratelogo'],
        )}
        href={url}
        rel="nofollow noopener noreferrer"
        style={{ ...sizes, backgroundImage: `url(${bgImage})` }}
        target="_blank"
      >
        <div className={styles['wrapper']}>
          <div className={styles['logo']}>
            <img alt={title} className={styles['logo-image']} src={logo} />
          </div>
          <div className={styles['content']}>
            <div className={styles['info']}>
              <div className={styles['label']}>{label}</div>
              <div className={styles['title']}>
                <UIHeading1 color="text-inverted-default">{title}</UIHeading1>
              </div>
              <div className={styles['text']}>
                <UIHeading2 color="text-inverted-default">{text}</UIHeading2>
              </div>
            </div>
            {buttonText && (
              <div className={styles['control']}>
                <Button theme="fill_white_primary" type="button">
                  {buttonText}
                </Button>
              </div>
            )}
          </div>
        </div>
        {disclaimer && (
          <div className={styles['note']}>
            <Marquee text={disclaimer} textPadding="s" />
          </div>
        )}
        {withMortgageAnnotations && (
          <div className={styles['mortgage-disclaimer']}>
            <MortgageAnnotations
              height={sizes.height}
              mortgageTermsWarning={mortgageTermsWarning}
              mortgageWarning={mortgageWarning}
            />
          </div>
        )}
      </a>
    </div>
  );
};
